export const GloneEN = {
    "glone": {
        "columns": {
            "code": "Code",
            "name": "Name",
            "gloneCfgPosition": "Position",
            "creator": "Creator",
        },
        "label": {
            "name": "Name",
            "code": "Code",
            "positions": "Positions",
            "ordinal": "Ordinal",
            "typeSalaryId": "Salary type",
            "primaryMoney": "Primary money",
        }
    }

}